<div class="controls-row" role="toolbar" aria-label="Chart controls">

  <!-- Color-by toggle -->
  <div class="control-group">
    <span class="control-label">Color by</span>
    <mat-button-toggle-group
      [value]="colorBy()"
      (change)="colorByChange.emit($event.value)"
      aria-label="Color sessions by"
    >
      <mat-button-toggle value="rig">Rig</mat-button-toggle>
      <mat-button-toggle value="operator">Operator</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Legend -->
  @if (palette().length > 0) {
    <div class="legend" aria-label="Color legend">
      @for (entry of palette(); track entry.id) {
        <span class="legend-item">
          <span class="legend-swatch" [style.background-color]="entry.color" aria-hidden="true"></span>
          <span class="legend-text">{{ entry.label }}</span>
        </span>
      }
    </div>
  }

  <!-- Time-scale selector + navigation arrows -->
  <div class="control-group control-group--right">
    <span class="control-label">View</span>
    <mat-button-toggle-group
      [value]="timeScale()"
      (change)="timeScaleChange.emit($event.value)"
      aria-label="Time scale"
    >
      <mat-button-toggle value="week">Week</mat-button-toggle>
      <mat-button-toggle value="month">Month</mat-button-toggle>
    </mat-button-toggle-group>

    <div class="nav-arrows" role="group" [attr.aria-label]="'Navigate ' + timeScale()">
      <button
        class="nav-btn"
        type="button"
        [attr.aria-label]="'Previous ' + timeScale()"
        (click)="navigate.emit(-1)"
      >‹</button>
      <button
        class="nav-btn"
        type="button"
        [attr.aria-label]="'Next ' + timeScale()"
        (click)="navigate.emit(1)"
      >›</button>
    </div>
  </div>

</div>
